export class Random {
    nextInt(n) {
        return Math.floor(Math.random() * n);
    }
    nextBoolean() {
        return Math.random() < 0.5;
    }
}
